var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEditRightIcon = function SvgEditRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.307 3c1.098 0 1.996.85 2.072 1.929l.005.148v4.687l-1.385-1.385V6.462h-18v12.461c0 .35.262.64.6.686l.093.006h16.615c.35 0 .64-.26.686-.598l.007-.094-.001-1.301 1.385-1.385v2.686c0 1.097-.85 1.996-1.928 2.072l-.149.005H3.692a2.076 2.076 0 0 1-2.072-1.929l-.005-.148V5.077c0-1.097.85-1.997 1.929-2.072L3.692 3h16.615zm-2.308 4.845v.693H5.077v9h12.922v.692H4.385V7.847H18zM19.5 9l4 4-4 4v-3h-4v-2h4V9z"
  })));
};

export default SvgEditRightIcon;